import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * Fetch timeslots for a given date and shipping method.
 *
 * @param {string} ymd - The year-month-day string.
 * @param {string} shippingMethod - The selected shipping method.
 * @returns {Promise<Object>} - The response from the API.
 */
export const fetchTimeslotsOnDate = async (ymd, shippingMethod, context = '') => {
    const params = {
        date: ymd,
        shipping_method: shippingMethod,
        context: context,
    };

    try {
        const response = await apiFetch({
            path: addQueryArgs('/iconic_wds/v1/get_slots_on_date', params)
        });
        return response;
    } catch (error) {
        console.error('Error fetching timeslots:', error);
        throw error;
    }
};

/**
 * Fetch checkout data including bookable dates
 * 
 * @param {string} shippingMethod - Selected shipping method
 * @returns {Promise<Object>} - Response data
 */
export const getCheckoutData = async (shippingMethod, context = '') => {
    const params = {
        shipping_method: shippingMethod,
        format: 'array',
        context: context,
    };

    try {
        const response = await apiFetch({
            path: addQueryArgs('/iconic_wds/v1/get_checkout_data', params),
        });
        return response;
    } catch (error) {
        console.error('Error fetching checkout data:', error);
        throw error;
    }
}; 

/**
 * Get subscription data from the cart
 * 
 * @returns {Promise<Object>} - Subscription data
 */
export const getSubscriptionData = async () => {
    return apiFetch({
        path: '/iconic_wds/v1/get_cart_subscription_data',
    });
}

/**
 * Save subscription data to the cart
 * 
 * @param {string} ymd - The year-month-day string
 * @param {string} timeslot - The selected timeslot
 * @param {string} productId - The product ID
 * @param {string} type - The type of product
 */
export const saveSubscriptionData = async (ymd, timeslot, productId, type ) => {
    return apiFetch({
        path: '/iconic_wds/v1/save_subscription_slot_session',
        method: 'POST',
        data: {
            date_ymd: ymd,
            timeslot: timeslot,
            product_id: productId,
            type: type,
        },
    });
}
